import convert from 'convert-units'

type DistanceValue = {
  value: string | number
  unit: string
}

export function sumDistances(
  values: DistanceValue[],
  convertToUnit: string,
): number {
  return values.reduce((accum, value) => {
    const num = Number(value.value)
     
    const convertedNum = convert(num).from(value.unit as any).to(convertToUnit as any)
    return accum + convertedNum
  }, 0)
}

type NumericValue = {
  value: string | number
}

export function sumValues(values: NumericValue[]): number {
  return values.reduce((accum, value) => {
    return accum + Number(value.value)
  }, 0)
}
